export default __webpack_public_path__ + "static/media/Level3-Snipet.114d265e.jpg";